import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "nav-image-container"
};
const _hoisted_2 = {
  class: "nav-description-container"
};
import ImageWithAlt from '../ImageWithAlt.vue';
export default {
  __name: 'NavBarProductTile',
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    image: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["menu-tile", {
          'active': __props.isActive
        }])
      }, [_createElementVNode("div", _hoisted_1, [_createVNode(ImageWithAlt, {
        src: __props.image,
        fit: "contain"
      }, null, 8, ["src"])]), _createElementVNode("div", _hoisted_2, [_createElementVNode("h4", null, _toDisplayString(__props.name), 1), _createElementVNode("h5", null, _toDisplayString(__props.description), 1)])], 2);
    };
  }
};